module.exports = __webpack_public_path__ + "img/mr_head_ic0.a8cc4307.jpg";